import SummaryWhy1 from '../components/recommendation/cards/summaryWhy1';
import S80c1 from '../components/recommendation/cards/S80c1';
import MutualFunds from '../components/recommendation/cards/mutualFunds';
import OtherInvestments from '../components/recommendation/cards/otherInvestments';
import SummaryHow1 from '../components/recommendation/cards/summaryHow1';
import SummaryHow2 from '../components/recommendation/cards/summaryHow2';
import InvestmentPlanGrowth from '../components/recommendation/cards/investmentPlanGrowth';
import InvestmentPlanTax from '../components/recommendation/cards/investmentPlanTax';
import SummaryWhy2 from '../components/recommendation/cards/summaryWhy2';
import DontDoFD from '../components/recommendation/cards/dontDoFD';
import DontdoSB from '../components/recommendation/cards/dontDoSB';
import FDSIP from '../components/recommendation/cards/fdsip';
import S80c2 from '../components/recommendation/cards/80c2';
import Family1 from '../components/recommendation/cards/family1';
import InvestmentPlanFD from '../components/recommendation/cards/investmentPlanFD';
import InvestmentPlanFamily from '../components/recommendation/cards/investmentPlanFamily';
import InvestmentPlanWealth from '../components/recommendation/cards/investmentPlanWealth';
import TwodaySalary from '../components/recommendation/cards/twoDaysalary';
import DreamHome1 from '../components/recommendation/cards/dreamHome1';
import EuroTrip1 from '../components/recommendation/cards/euroTrip1';
import InvestmentPlanGrowthFamily from '../components/recommendation/cards/investmentPlanGrowthFamily';
import SummaryWhyFD from '../components/recommendation/cards/summaryWhyFD';
import {
  UserApiSchema,
  PersonalInfoApiSchema,
} from '../components/recommendation/models';

// TODO: Remove this as soon as the proper data comes in.
export const apiRes: UserApiSchema = {
  _d: 'filing_raw',
  EntityGuid: '520e7caa-91bf-4fd9-9427-54e9110f16c9',
  UserExternalID: 'fba206a9-01fb-4aa2-b967-d278097f7de1',
  YearOfBirth: 1990,
  YearOfInterest: '2017-18',
  SalaryIncome: 850000,
  TaxableSalary: 850000,
  FixedDepositIncome: 0,
  SavingsInterestIncome: null,
  HomeLoan: false,
  MutualFundInvestments: false,
  ShareInvestments: false,
  Deduction80C: 50000,
  Deduction80DInsurance: 2000,
  Deduction80DHealthCheck: null,
  MaritalStatus: 'Unmarried',
  Gender: 'Male',
  City: 'Kolkata',
  Id: null,
  AnonId: 'ec02248d-1741-4aa6-9ca2-9eb218aa4e94',
  CreateTimestamp: '2018-07-15T14:58:06.8497431Z',
  UpdateTimestamp: '2018-07-15T14:58:06.8497431Z',
};

export const personalInfoApiRes: PersonalInfoApiSchema = {
  success: true,
  httpStatus: 200,
  message: null,
  response: {
    permanentInfoDetails: {
      firstName: 'Mayank',
      middleName: null,
      lastName: '',
      fatherName: 'A.K Sinha',
      maritalStatus: 'Unmarried',
      gender: 'Male',
      pan: 'BNRPA7250H',
      dateofBirth: '16/06/1996',
      validationErrors: [],
    },
    accountDetails: {
      nameOfBank: 'ICICI',
      accountNumber: '002001609305',
      ifscCode: 'ICIC0000020',
    },
    addressInfoDetails: {
      flatDoorBlockNumber: '202',
      premiseBuildingVillageName: null,
      roadStreetPostOffice: 'bangalore',
      areaLocality: 'bangalore',
      townCityDistrict: 'bangalore',
      stateInIndia: 'karnataka',
      country: 'INDIA',
      pinCode: 56008,
      mobile: '7411883517',
      email: 'mayank-test-account@cleartax.in',
      emailSec: null,
      aadharEnrollmentNumber: '',
      aadhaarCardNumber: null,
      validationErrors: [],
    },
  },
};

export interface UserData {
  name?: string;
  age?: number;
  income?: number;
  fd?: number;
  sb?: number;
  kids?: boolean;
  kyc?: string;
  homeLoan?: boolean;
  hra?: boolean;
  married?: boolean;
  capitalGains?: boolean;
  investments80C?: number;
  taxableSalary?: number;
  deduction80DInsurance?: number;
  deduction80DHealthCheck?: number;
  firstName?: string;
  // insurance?: string;
}

export interface WhatsAppData {
  name?: string;
  income?: number;
  age?: number;
  married?: boolean;
  dob?: string;
  mobileNumber?: string;
  gender?: string;
  panNumber?: string;
  pincode?: number;
  city?: string;
  fd?: number;
  sb?: number;
  investments80C?: number;
  taxableSalary?: number;
  deduction80DInsurance?: number;
  deduction80DHealthCheck?: number;
  homeLoan?: boolean;
}

const taxBrackets = [
  {
    minIncome: 0,
    maxIncome: 250000 - 1,
    taxPercent: 0,
  },
  {
    minIncome: 250000,
    maxIncome: 500000 - 1,
    taxPercent: 5,
  },
  {
    minIncome: 500000,
    maxIncome: 1000000 - 1,
    taxPercent: 20,
  },
  {
    minIncome: 1000000,
    maxIncome: 10000000,
    taxPercent: 30,
  },
];

/**
 * This is recommendation ENUMs
 */

// age
export const ageEnums = {
  1: {
    to: 25,
  },
  2: {
    from: 26,
    to: 30,
  },
  3: {
    from: 31,
    to: 35,
  },
  4: {
    from: 36,
  },
};

// income
export const incomeEnums = {
  1: {
    to: 700000,
  },
  2: {
    from: 700001,
    to: 1500000,
  },
  3: {
    from: 1500001,
    to: 2500000,
  },
  4: {
    from: 2500001,
  },
};

export const calculateMonthlySIP = (
  totalAmount: number,
  years: number,
  interest: number
) => {
  const monthlyRate = interest / 100 / 12;
  return Math.round(
    (1 /
      (((1 / totalAmount) * (Math.pow(1 + monthlyRate, years * 12) - 1)) /
        monthlyRate)) *
      (1 + monthlyRate)
  );
};

export const calculateSipFutureValue = (
  sipAmount: number,
  years: number,
  interest: number
) => {
  const monthlyRate = interest / 12 / 100;
  return (
    ((sipAmount * (Math.pow(1 + monthlyRate, years * 12) - 1)) / monthlyRate) *
    (1 + monthlyRate)
  );
};

export const calculateLumpsumFutureValue = (
  amount: number,
  years: number,
  interest: number
) => {
  const yearlyRate = interest / 100;

  return amount * Math.pow(1 + yearlyRate, years);
};

export const calculateFinances = (data: UserData) => {
  // Reset everything
  let fdBetter = 0;
  let totalTaxSavings = 0;
  let aggressivePlan = 0;
  let balancedPlan = 0;

  const {
    investments80C,
    taxableSalary,
    deduction80DInsurance,
    deduction80DHealthCheck,
    fd = 0,
  } = data;

  const refinedTaxableSalary = taxableSalary || 0;

  // Calculate 80C Deduction
  // const isDeductionComplete = data.investments80C / 100000 > 1.4;

  // Calculate Salary
  const netTaxableSalary =
    Number(refinedTaxableSalary) -
    (Number(investments80C) +
      Number(deduction80DInsurance || 0) +
      Number(deduction80DHealthCheck || 0));

  const rawSipAmount = Math.round(refinedTaxableSalary / 180);
  const sipAmount = Math.round(rawSipAmount / 1000) * 1000;

  // Calculate Bracket
  let bracketPercent = 0;
  taxBrackets.forEach((b: any) => {
    if (netTaxableSalary >= b.minIncome && netTaxableSalary < b.maxIncome) {
      bracketPercent = b.taxPercent;
    }
  });

  // calculate taxpaid
  let taxPaid = 0;
  taxPaid = (netTaxableSalary - 250000) * (bracketPercent / 100);

  // less tax rebate if applicable
  if (data.income <= 350000) {
    taxPaid = taxPaid - Math.min(taxPaid, 2500);
  }

  const availableInvAmount80C = Math.max(
    Math.min(150000, taxableSalary) - investments80C,
    0
  );
  const investmentAmountForTaxPaid = bracketPercent
    ? taxPaid * (100 / bracketPercent)
    : 0;

  const maxInvAmount80C = Math.min(
    150000,
    investmentAmountForTaxPaid + investments80C
  );

  const returnsOnMax80C = maxInvAmount80C * 0.18;

  // Calculation of Tax Savings
  const initialTaxSavings = investments80C * (bracketPercent / 100);
  const taxSavings = availableInvAmount80C * (bracketPercent / 100);

  const savingsBeforeReturn = Math.min(taxPaid, taxSavings);

  // return calculation for remaining 80C amount
  const additionalIncome = investmentAmountForTaxPaid
    ? Math.min(investmentAmountForTaxPaid, availableInvAmount80C) * 0.18
    : availableInvAmount80C * 0.18;
  // T *otal Tax Savings
  totalTaxSavings = savingsBeforeReturn + additionalIncome;

  // Calculation of FD
  const fdPrincipal = fd / 0.06;
  const fdActual = Math.round(fd * ((100 - bracketPercent) / 100));
  fdBetter = Math.round(fdPrincipal * 0.081);

  // Calculation of Aggressive Plan
  const aggressiveYears = 25;
  const aggressivePercent = 15;
  aggressivePlan = calculateSipFutureValue(
    sipAmount,
    aggressiveYears,
    aggressivePercent
  );

  // Calculation of Balanced Plan
  balancedPlan = Math.round((refinedTaxableSalary / 180) * 1.18);

  // Calculation of Everything
  const everything = Math.round(totalTaxSavings + fdBetter + aggressivePlan);
  return {
    initialTaxSavings,
    taxSavings,
    additionalIncome,
    totalTaxSavings,
    bracketPercent,
    availableInvAmount80C,
    fdActual,
    fdBetter,
    sipAmount,
    aggressiveYears,
    aggressivePercent,
    aggressivePlan,
    balancedPlan,
    everything,
    maxInvAmount80C,
    returnsOnMax80C,
    netTaxableSalary,
  };
};

export const decidePortfolio = (user: UserData) => {
  const { income, investments80C } = user;

  if (investments80C < 150000) {
    return 'ts';
  } else if (income <= 700000 && investments80C <= 100000) {
    return 'ts';
  } else if (income <= 700000 && investments80C > 100000) {
    return 'mf';
  } else if (income > 700000 && income <= 1000000 && investments80C <= 100000) {
    return 'ts';
  } else if (
    income > 700000 &&
    income <= 1000000 &&
    investments80C > 100000 &&
    investments80C <= 140000
  ) {
    return 'both';
  } else if (
    income > 700000 &&
    income <= 1000000 &&
    investments80C > 100000 &&
    investments80C > 140000
  ) {
    return 'mf';
  } else if (income > 1000000 && investments80C < 140000) {
    return 'both';
  } else if (income > 1000000 && investments80C >= 140000) {
    return 'mf';
  }
};

export const formatRupeeLiteral = (value: number) => {
  if (!value) {
    return 0;
  }
  let temp;
  if (value > 10000000) {
    temp = `${parseFloat((value / 10000000).toFixed(2)).toLocaleString(
      'en-IN'
    )} Crore`;
  } else if (value > 100000) {
    temp = `${parseFloat((value / 100000).toFixed(2)).toLocaleString(
      'en-IN'
    )} Lakhs`;
  } else {
    temp = `${parseInt(value.toString(), 10).toLocaleString('en-IN')}`;
  }
  return temp;
};
/**
 * This is the map that defines the relation of the
 * attributes to the components.
 */
export const cardMap = {
  summaryWhy1: SummaryWhy1,
  summaryWhy2: SummaryWhy2,
  summaryWhyFD: SummaryWhyFD,
  '80c1': S80c1,
  '80c2': S80c2,
  mutualFunds: MutualFunds,
  otherInvestments: OtherInvestments,
  summaryHow1: SummaryHow1,
  summaryHow2: SummaryHow2,
  investmentPlanGrowth: InvestmentPlanGrowth,
  investmentPlanTax: InvestmentPlanTax,
  investmentPlanFD: InvestmentPlanFD,
  dontDoFD: DontDoFD,
  dontDoSB: DontdoSB,
  fdSIP: FDSIP,
  family1: Family1,
  investmentPlanFamily: InvestmentPlanFamily,
  investmentPlanWealth: InvestmentPlanWealth,
  twoDaySalary: TwodaySalary,
  dreamHome1: DreamHome1,
  euroTrip1: EuroTrip1,
  investmentPlanGrowthFamily: InvestmentPlanGrowthFamily,
};

const TaxSavingStory1 = ['summaryWhy1', '80c1', 'investmentPlanTax'];

const TaxSavingStory2 = ['summaryWhy1', '80c2'];

const MutualFundStory1 = ['summaryWhy2', 'mutualFunds', 'investmentPlanGrowth'];

const fdStory = ['summaryWhyFD', 'dontDoFD', 'investmentPlanFD'];

const sbStory = ['dontDoSB', 'investmentPlanFD'];

const familyStory = ['family1', 'investmentPlanFamily'];

const MutualFundAndFamilyStory = [
  'summaryWhy2',
  'mutualFunds',
  'summaryHow1',
  'investmentPlanGrowthFamily',
];

const wealthMgmtStory = [
  'summaryWhy2',
  'mutualFunds',
  'summaryHow1',
  'investmentPlanWealth',
];

const eurotripStory = ['euroTrip1', 'investmentPlanGrowth'];

const twoDaySalaryStory = [
  'twoDaySalary',
  'summaryHow2',
  'investmentPlanGrowth',
];

const tooSafeStory = [];

const dreamHomeStory = ['dreamHome1', 'investmentPlanGrowth'];

export const stories = {
  TaxSavingStory1,
  TaxSavingStory2,
  MutualFundStory1,
  fdStory,
  sbStory,
  familyStory,
  wealthMgmtStory,
  eurotripStory,
  twoDaySalaryStory,
  tooSafeStory,
  dreamHomeStory,
  MutualFundAndFamilyStory,
};



// WEBPACK FOOTER //
// ./constants/recommendationData.ts